// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"2975":"stock","7962":"home"}[chunkId] || chunkId) + "." + {"569":"ccba5e7b","2975":"7dc86287","7962":"3003a539"}[chunkId] + ".css";
};